var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 266,
    viewBox: "0 0 266 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 133,
    r: 133,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.15 162.3L205.05 79H238.2L193.15 198H159.15L114.1 79H147.25L176.15 162.3Z",
    fill: "url(#paint0_linear_18_150)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.1 90.5542V150.4L72.3 79H40V198H70.6V126.6L111.4 198H143.7V171.859L113.1 90.5542ZM143.7 157.092V79H114.309L143.7 157.092Z",
    fill: "url(#paint1_linear_18_150)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_150",
    x1: 173.056,
    y1: 73.6246,
    x2: 173.454,
    y2: 225.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0044FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C14EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_150",
    x1: 89.0699,
    y1: 97.9382,
    x2: 89.2264,
    y2: 186.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0044FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C14EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.752bfe5202f55ea097b6d8bb5c7e1ad9.svg";
export { ForwardRef as ReactComponent };